(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cap-flip"] && !Shopify.designMode) return;
  try {
    
  class CapFlip extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.cap-flip__button');
      this.backImages = [...this.querySelectorAll('.cap-flip__back-image')];
      this.currentIndex = -1;
      this.isFlipped = false;

      if (this.backImages.length > 0) {
        this.showNextBack();
      }

      this.button.addEventListener('click', () => this.flip());
      this.button.addEventListener('mouseenter', () => this.flip());
      this.button.addEventListener('mouseleave', () => this.unflip());
      this.button.addEventListener('focus', () => this.flip());
      this.button.addEventListener('blur', () => this.unflip());
    }

    flip() {
      if (this.isFlipped) return;
      this.isFlipped = true;
      this.classList.add('is-flipped');
    }

    unflip() {
      if (!this.isFlipped) return;
      this.isFlipped = false;
      this.classList.remove('is-flipped');
      this.showNextBack();
    }

    showNextBack() {
      if (this.backImages.length === 0) return;
      this.backImages.forEach((img) => img.classList.remove('is-active'));
      this.currentIndex = (this.currentIndex + 1) % this.backImages.length;
      this.backImages[this.currentIndex].classList.add('is-active');
    }
  }

  customElements.define('cap-flip', CapFlip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
